/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeambulazioneTipoDTO
 */
export interface DeambulazioneTipoDTO {
    /**
     * 
     * @type {string}
     * @memberof DeambulazioneTipoDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DeambulazioneTipoDTO
     */
    descrizione?: string;
}

/**
 * Check if a given object implements the DeambulazioneTipoDTO interface.
 */
export function instanceOfDeambulazioneTipoDTO(value: object): value is DeambulazioneTipoDTO {
    return true;
}

export function DeambulazioneTipoDTOFromJSON(json: any): DeambulazioneTipoDTO {
    return DeambulazioneTipoDTOFromJSONTyped(json, false);
}

export function DeambulazioneTipoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeambulazioneTipoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function DeambulazioneTipoDTOToJSON(value?: DeambulazioneTipoDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'descrizione': value['descrizione'],
    };
}

